import { render, staticRenderFns } from "./gRow.vue?vue&type=template&id=5c0eec05&scoped=true&"
import script from "./gRow.vue?vue&type=script&lang=js&"
export * from "./gRow.vue?vue&type=script&lang=js&"
import style0 from "./gRow.vue?vue&type=style&index=0&id=5c0eec05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0eec05",
  null
  
)

component.options.__file = "gRow.vue"
export default component.exports